/**
 * Portal Manta · Tokens de tipografia
 * Extraído de portal_manta_v28_12.jsx (linhas 164-168)
 */

export const F = {
  display: "'Montserrat', 'Arial Black', sans-serif",
  body:    "'Inter', system-ui, sans-serif",
  mono:    "'JetBrains Mono', 'Courier New', monospace",
};

// Escala de tamanhos sugerida (v29 · consolidação)
export const SIZE = {
  xxs: 9,
  xs:  10,
  sm:  11,
  base: 12,
  md:  13,
  lg:  15,
  xl:  18,
  xxl: 22,
  hero: 28,
};

export default F;
